import firebase from 'firebase'
import 'firebase/auth';

export const state = {
  sageIntegration: {
    active: false,
    invoicing: false,
    customers: false,
    inventory: false
  },
  qbIntegration: {
    active: false,
    invoicing: false,
    customers: false,
    realmId: null,
    defaultAccount: {
      name: null,
      id: null,
      sync_token: null
    },
  },
  workOrders: {
    repair_hours_enabled: false,
    repair_cost_enabled: false,
    labour_hours_enabled: false,
    email_notification_enabled: true //enabled by default
  },
  currentUserData: null,
}

export const mutations = {
  CHANGE_SAGE_INTEGRATION_STATUS(state, statusObj) {
    state.sageIntegration = statusObj;
  },
  CHANGE_QB_INTEGRATION_STATUS(state, statusObj) {
    state.qbIntegration = statusObj;
  },
  UPDATE_COMPANY_SETTINGS(state, settings) {
    state.workOrders.repair_hours_enabled = settings.work_orders.repair_hours;
    state.workOrders.repair_cost_enabled = settings.work_orders.repair_cost;
    state.workOrders.labour_hours_enabled = settings.work_orders.labour_hours;
    state.workOrders.email_notification_enabled = settings.work_orders.email_notification_enabled;
  },
  UPDATE_USER_DATA(state, newUserData) {
    state.currentUserData = newUserData;
  }
}

export const actions = {

  updateSageStatus({ commit }, { sageStatus }) {
    //update the session storage as well.
    console.log('Updating sage status in store.');
    console.log(sageStatus)
    sessionStorage.setItem('sage_invoicing', sageStatus.invoicing);
    sessionStorage.setItem('sage_customers', sageStatus.customers);
    sessionStorage.setItem('sage_inventory', sageStatus.inventory);
    commit('CHANGE_SAGE_INTEGRATION_STATUS', sageStatus);
  },

  updateQBStatus({ commit }, { qbStatus }) {
    //update the session storage as well.
    console.log('Updating QBO status in store.');
    console.log(qbStatus)
    sessionStorage.setItem('qb_invoicing', qbStatus.invoicing);
    sessionStorage.setItem('qb_customers', qbStatus.customers);
    sessionStorage.setItem('qb_realmId', qbStatus.realmID);
    sessionStorage.setItem('qb_defaultAccountId', qbStatus.defaultAccount.id);
    sessionStorage.setItem('qb_defaultAccountName', qbStatus.defaultAccount.name);
    commit('CHANGE_QB_INTEGRATION_STATUS', qbStatus);
  },

  updateCompanySettings({ commit }, { settings }) {
    //update the session storage as well.
    commit('UPDATE_COMPANY_SETTINGS', settings);
  },

  async updateUserData({ commit }, newUserData) {
    await commit('UPDATE_USER_DATA', newUserData)
  },

  async getUserData({ commit }) {
    try {
      firebase.auth().onAuthStateChanged(async user => {
        if (user) {
          // User is signed in.
          await firebase.firestore()
            .collection('employees')
            .doc(user.uid)
            .get()
            .then(async (doc) => {
              if (doc.exists) {
                await commit('UPDATE_USER_DATA', {uid: doc.id, ...doc.data()})
              }
            });
        } else {
          console.log("No user is signed in");
        }
      });
    } catch (err) {
      console.log('Error retrieving current user data in store: ', err);
    }
  }

}